export default {
  mutations: {
    setContact(state, payload) {
      state.contacts = payload;
    },
  },
};
